import { request } from "utils";

const url = "request/urgent-count";

// => { total: number, mine: number }
export async function callGetUrgentRequestCount() {
  // isQuiet: được gọi định kỳ (polling), không bật thông báo lỗi
  const res = await request.get(url, {}, true);
  return res || { total: 0, mine: 0 };
}

export default callGetUrgentRequestCount;
